import type { FC } from 'react';

import { Tooltip } from '~/components/Tooltip';

interface ChannelHintIconProps {
  Icon: FC<{ className?: string; 'aria-hidden'?: boolean | 'true' }>;
  hint: string;
  /** Focusable badge whose tooltip also opens on click. Not valid inside the option rows,
   * whose `<label>` forbids nested controls. */
  interactive?: boolean;
}

/** Channel indicator whose meaning is spelled out on hover, and on click when interactive. */
export const ChannelHintIcon: FC<ChannelHintIconProps> = ({ Icon, hint, interactive = false }) => (
  <Tooltip
    content={<span className="block max-w-[240px]">{hint}</span>}
    placement="top-end"
    interactive={interactive}
    className={interactive ? 'inline-flex shrink-0' : 'ml-auto flex items-center'}
  >
    {interactive ? (
      // size-6 is the 24px WCAG target; the inner circle matches the sidebar's lock indicator.
      <button type="button" aria-label={hint} className="inline-flex size-6 cursor-help items-center justify-center">
        <span className="flex size-5 items-center justify-center rounded-full bg-black/[0.04] text-black/50">
          <Icon aria-hidden="true" className="size-3 shrink-0" />
        </span>
      </button>
    ) : (
      <>
        <Icon aria-hidden="true" className="size-3.5 shrink-0 cursor-help text-black/40" />
        {/* Hover-only here, so the hint needs a screen-reader copy. */}
        <span className="sr-only">{hint}</span>
      </>
    )}
  </Tooltip>
);
